import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
} from "@chakra-ui/react";
import React, { memo } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const RelativeFormRequestFormInfo = memo(({ isOpen, onClose, value }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"625px"}
        h={"max-content"}
      >
        <Flex
          alignItems={"center"}
          p={"25px 24px 24px 24px"}
          position={"relative"}
          borderBottom={"1px solid var(--border-input-employee)"}
        >
          <Text
            color={"var(--color-header-employee)"}
            fontSize={"16px"}
            fontWeight={"600"}
          >
            Chi tết phiếu đăng ký cộng tác viên
          </Text>
          <Box
            position={"absolute"}
            top={"24px"}
            right={"24px"}
            cursor={"pointer"}
            onClick={onClose}
          >
            <Image src={IconX} />
          </Box>
        </Flex>
        <Box p={"24px"}>
          <Text
            color={"var(--color-header-employee)"}
            fontSize={"16px"}
            fontWeight={"600"}
          >
            {value?.name} {value?.job ? `(${value?.job})` : null}
          </Text>
        </Box>
        <Box p={"0px 40px 24px 40px"}>
          <Box margin={"0 auto"}>
            <Flex>
              <Box flex={1}>
                {/*  */}
                <Box>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Thông tin cộng tác viên
                  </Text>
                  <Box
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    mt={"13px"}
                    borderRadius={"8px"}
                  >
                    <Flex gap={"27px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Họ tên
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.fullName || "-"}
                        </Text>
                      </Box>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Mã số nhân viên
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.code || "-"}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex gap={"27px"} mt={"16px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Số điện thoại
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.phone || "-"}
                        </Text>
                      </Box>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Email
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.email || "-"}
                        </Text>
                      </Box>
                    </Flex>

                    <Flex gap={"27px"} mt={"16px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Ngày vào làm
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.startTime || "-"}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                </Box>

                {/*  */}
                <Box mt={"20px"}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Thông tin nhân viên tạo
                  </Text>
                  <Box
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    mt={"16px"}
                    borderRadius={"8px"}
                  >
                    <Flex gap={"27px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Họ tên
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.creatorName || "-"}
                        </Text>
                      </Box>
                    </Flex>
                    <Flex gap={"27px"} mt={"16px"}>
                      <Box flex={"1"}>
                        <Text
                          color={"var(--color-label-employee)"}
                          fontSize={"12px"}
                        >
                          Mã nhân viên
                        </Text>
                        <Text
                          color={"var(--color-option-employee)"}
                          fontSize={"14px"}
                          fontWeight={"500"}
                          mt={"8px"}
                        >
                          {value?.creatorCode || "-"}
                        </Text>
                      </Box>
                    </Flex>
                  </Box>
                </Box>
              </Box>
            </Flex>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
});

export default RelativeFormRequestFormInfo;
